import { createSelector } from 'reselect';
import { selectGates } from '../reducers/Portal';
const getGateName = (_, {
  gateName
}) => gateName;
export const selectIsGateUngated = createSelector([selectGates, getGateName], (gates, gateName) => gates.includes(gateName));